<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-arrow-down"
    :width="props.width"
    :height="props.height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 5l0 14"></path>
    <path d="M18 13l-6 6"></path>
    <path d="M6 13l6 6"></path>
  </svg>
</template>

<script lang="ts" setup>
export interface IconListProps {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IconListProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
